import { Injectable } from '@angular/core';
import { TokenService } from './token.service';

import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor() { }

  encrypt(data:string) {
    return CryptoJS.AES.encrypt(data, this.getSecret()).toString();
  }

  decrypt(data:string) {
    return CryptoJS.AES.decrypt(data, this.getSecret()).toString(CryptoJS.enc.Utf8);
  }

  getSecret() {
    return 'AncvModeration2020';
  }
}
